import { Button } from 'antd'
import { Moon, Sun } from 'lucide-react'
import { useThemeMode } from './store'

export default function ThemeModeSelect() {
  const { mode, setMode } = useThemeMode()
  const label = mode === 'dark' ? '深色模式' : '浅色模式'
  const nextLabel = mode === 'dark' ? '浅色模式' : '深色模式'
  return (
    <Button
      className="theme-mode-select"
      aria-label={`当前${label}，切换为${nextLabel}`}
      title={`切换为${nextLabel}`}
      icon={mode === 'dark' ? <Moon size={18} /> : <Sun size={18} />}
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
    />
  )
}
